import { render, staticRenderFns } from "./series.vue?vue&type=template&id=58d8b72a&"
import script from "./series.vue?vue&type=script&lang=ts&"
export * from "./series.vue?vue&type=script&lang=ts&"
import style0 from "./series.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports